import { useSelector } from "react-redux";
import { RootState } from "../store";
import { SkusReducerState } from "../store/reducers/skusReducer";

const useSkus = (): SkusReducerState =>
  useSelector((state: RootState) => state.skusReducer);

export default useSkus;
